import FieldSet from '../../FieldSet';

import { TimeFrame } from './TimeFrame';

export class EpochFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TimeFrame];
  }

  get title() {
    return 'Time frame';
  }
}
